import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radio1",
  "use": "icon-radio1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-radio1\"><path fill=\"#333333\" d=\"M832 512H320V314.24a96 96 0 1 0-64 0V512H192a96.288 96.288 0 0 0-96 96v160a96.288 96.288 0 0 0 96 96h640a96.288 96.288 0 0 0 96-96v-160a96.288 96.288 0 0 0-96-96zM288 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32z m448 512h-128a32 32 0 0 1 0-64h128a32 32 0 0 1 0 64z m0-96h-128a32 32 0 0 1 0-64h128a32 32 0 0 1 0 64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol